import { ListBooking } from 'types';
import ConnectStayRating from 'components/StayRating';

export const StayRating = ({ booking }: { booking: ListBooking }) => <ConnectStayRating booking={booking} mb={[0, 2]} />;
